<template>
	<div class="stickers-container">
		<div class="stickers">
			<p class="stickers__title"> Upmood Stickers</p>

			<header class="stickers__header">
				<p class="count">
					Total Stickers: {{ count }}
				</p>

				<div class="stickers__controls">
					<AppButton
						modifier="small-primary"
						@click="$router.push({name : 'add-stickers'})"
					>
						Add Sticker
					</AppButton>

					<AppTextField
						placeholder="Search"
						icon-right="search"
					/>
				</div>
			</header>

			<div
				v-if="!stickersLoading"
				class="stickers__list"
			>
				<div
					class="sticker"
					v-for="sticker in stickers.data"
					:key="sticker.id"
					@click="$router.push({ name: 'view-stickers', params: { name: sticker.set_name.toLowerCase().split(' ').join('-') }})"
				>
					<div class="sticker__image">
						<AppImage
							class="image"
							:title="sticker.set_name"
							:src="`${URL}img/resources/${sticker.filepath}`"
							:fallback="require('@/assets/img/default-emoji.png')"
						/>
					</div>

					<p class="sticker__name">
						{{ sticker.set_name }}
					</p>
				</div>
			</div>

			<div
				v-else
				class="stickers__loading"
			>
				<AppLoading/>
			</div>

			<footer class="stickers__footer">
				<p class="pages">{{ 1 }} to {{ 100 }}</p>

				<div>
					<AppCountPicker
						placeholder="Item"
						min="10"
						max="60"
						step="10"
						v-model="itemCount"
					/>

					<AppPagination
						class="paginate"
						v-model="currentPage"
						:total="total"
					/>
				</div>
			</footer>
		</div>
	</div>
</template>

<script>
import * as stickerModule from '@/store/sticker'
import { mapFields } from 'vuex-map-fields'

export default {
	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['sticker/']) {
			this.$store.registerModule('sticker', stickerModule.default)
		}
	},

	created () {
		const { keyword } = this.$route.query

		this.keyword = keyword || ''

		this.getList()
	},

	data () {
		return {
			count: 20,
			currentPage: 1,
			total: 10,
			itemCount: 10,
			URL: process.env.VUE_APP_BASE,
			keyword: ''
		}
	},

	computed: {
		...mapFields('sticker', [
			'stickers',
			'stickersLoading',
			'viewDetails'
		])
	},

	methods: {
		search () {
			clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
				this.getList()
			}, 500)
		},

		getList () {
			const form = new FormData()
			form.append('keyword', this.keyword)

			const query = {}
			if (this.keyword) {
				query.keyword = this.keyword
			}

			this.$router.push({ query: query })
			this.$store.dispatch('sticker/getList', form)
		},

		viewSticker ({ set_name, id }) {
			const name = set_name.toLowerCase().split(' ').join('-')
			this.viewDetails.id = id
			this.$router.push({ name: 'view-stickers', params: { name } })
		},

		editItem (item) {
			console.log(item)
		},

		deleteItem (item) {
			console.log(item)
		},

		changePage (pagination) {
			this.paginate.currentPage = pagination.currentPage
			this.paginate.itemsPerPage = pagination.itemsPerPage
		}
	}
}
</script>

<style lang="scss" scoped>
.stickers-container {
	height: 100%;
	padding: 1.5em;
}

.stickers {
	box-shadow: 0 0 3px $default-light;
	background-color: #fff;
	padding: 20px;
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;

	&__header, &__controls, &__footer {
		display: flex;
		align-items: center;
	}

	&__header, &__footer { justify-content: space-between;	}
	&__header { margin-bottom: 15px; }
	&__controls > * { margin-left: 1.5em; }
	.count { color: darken($default, 20%); }
	.pages { color: $default-light; }
	.paginate { margin-left: 50px; }

	&__list {
		flex: 1 1 auto;
		display: flex;
		flex-wrap: wrap;
		overflow: auto;
		margin-bottom: 15px;
	}

	.sticker {
		margin: 20px;
		cursor: pointer;

		&__image {
			height: 90px;
			width: 90px;
			padding: 15px;
			box-shadow: 0 0 2px $default-light;
			border-radius: 3px;
			margin-bottom: .5em;

			.image {
				width: 100%;
				height: 100%;
			}
		}

		&__name {
			text-align: center;
		}

		&:hover .sticker__image { box-shadow: 0 0 2px $primary; }
		&:hover .sticker__name { color: $primary; }
	}

	&__loading {
		height: 100%;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
}
</style>
